import * as React from "react";
import { memo } from "react";

const SvgHeatingAndAc = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.421 0H1.58A1.58 1.58 0 0 0 0 1.579v6.316a1.582 1.582 0 0 0 1.579 1.578H18.42A1.58 1.58 0 0 0 20 7.895V1.579A1.582 1.582 0 0 0 18.421 0ZM4.941 8.421l.702-2.105h8.714l.702 2.105H4.941Zm14.006-.526c0 .29-.236.525-.526.526h-2.252l-.933-2.798a.527.527 0 0 0-.5-.36H5.264a.527.527 0 0 0-.5.36L3.832 8.42H1.579a.527.527 0 0 1-.526-.526V1.579c0-.29.236-.526.526-.526h16.842c.29 0 .526.236.526.526v6.316Z"
      fill="#000"
    />
    <path
      d="M13.158 6.842H6.842a.526.526 0 1 0 0 1.053h6.316a.526.526 0 1 0 0-1.053ZM13.684 2.105H11.58a.526.526 0 1 0 0 1.053h2.105a.526.526 0 0 0 0-1.053ZM16.842 2.105H15.79a.526.526 0 0 0 0 1.053h1.053a.526.526 0 0 0 0-1.053ZM10.154 10.68l-.22.22a2.154 2.154 0 0 0-.405 2.493c.213.426.13.941-.208 1.278l-.22.22a.526.526 0 1 0 .744.744l.22-.22a2.156 2.156 0 0 0 .406-2.493c-.214-.425-.13-.94.207-1.277l.22-.22a.526.526 0 0 0-.744-.745ZM5.944 10.68l-.22.22a2.156 2.156 0 0 0-.405 2.493c.213.426.13.941-.208 1.278l-.22.22a.527.527 0 1 0 .744.744l.22-.22a2.157 2.157 0 0 0 .405-2.493c-.213-.425-.13-.94.208-1.277l.22-.22a.526.526 0 0 0-.744-.745ZM14.365 10.68l-.22.22a2.156 2.156 0 0 0-.405 2.493c.213.426.13.941-.208 1.278l-.22.22a.527.527 0 1 0 .744.744l.22-.22a2.158 2.158 0 0 0 .405-2.493c-.213-.425-.13-.94.208-1.277l.22-.22a.527.527 0 0 0-.744-.745Z"
      fill="#000"
    />
  </svg>
);

const Memo = memo(SvgHeatingAndAc);
export default Memo;
